/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getLaborIncidents } from 'app/entities/labor-incident/labor-incident.reducer';
import { createEntity, getEntity, reset, updateEntity } from './gynaec-checklist.reducer';

export const GynaecChecklistUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const laborIncidents = useAppSelector(state => state.laborIncident.entities);
  const gynaecChecklistEntity = useAppSelector(state => state.gynaecChecklist.entity);
  const loading = useAppSelector(state => state.gynaecChecklist.loading);
  const updating = useAppSelector(state => state.gynaecChecklist.updating);
  const updateSuccess = useAppSelector(state => state.gynaecChecklist.updateSuccess);

  const handleClose = () => {
    navigate(`/gynaec-checklist${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
    dispatch(getLaborIncidents({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...gynaecChecklistEntity,
      ...values,
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      incident: laborIncidents.find(it => it.id.toString() === values.incident?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...gynaecChecklistEntity,
          patient: gynaecChecklistEntity?.patient?.id,
          incident: gynaecChecklistEntity?.incident?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.gynaecChecklist.home.createOrEditLabel" data-cy="GynaecChecklistCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.gynaecChecklist.home.createOrEditLabel">Create or edit a GynaecChecklist</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="gynaec-checklist-id"
                  label={translate('tinyMedicRestApp.gynaecChecklist.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.motherAntibiotics')}
                id="gynaec-checklist-motherAntibiotics"
                name="motherAntibiotics"
                data-cy="motherAntibiotics"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.mChills')}
                id="gynaec-checklist-mChills"
                name="mChills"
                data-cy="mChills"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.mFsvd')}
                id="gynaec-checklist-mFsvd"
                name="mFsvd"
                data-cy="mFsvd"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.mLat')}
                id="gynaec-checklist-mLat"
                name="mLat"
                data-cy="mLat"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.mLateRuptureOfMembranes')}
                id="gynaec-checklist-mLateRuptureOfMembranes"
                name="mLateRuptureOfMembranes"
                data-cy="mLateRuptureOfMembranes"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.mDelayedLabour')}
                id="gynaec-checklist-mDelayedLabour"
                name="mDelayedLabour"
                data-cy="mDelayedLabour"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.bAntibiotics')}
                id="gynaec-checklist-bAntibiotics"
                name="bAntibiotics"
                data-cy="bAntibiotics"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.bAbnormalBreathing')}
                id="gynaec-checklist-bAbnormalBreathing"
                name="bAbnormalBreathing"
                data-cy="bAbnormalBreathing"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.bChestGrunting')}
                id="gynaec-checklist-bChestGrunting"
                name="bChestGrunting"
                data-cy="bChestGrunting"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.bConvulsions')}
                id="gynaec-checklist-bConvulsions"
                name="bConvulsions"
                data-cy="bConvulsions"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.bLooksSick')}
                id="gynaec-checklist-bLooksSick"
                name="bLooksSick"
                data-cy="bLooksSick"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.bTooCold')}
                id="gynaec-checklist-bTooCold"
                name="bTooCold"
                data-cy="bTooCold"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.bTooHot')}
                id="gynaec-checklist-bTooHot"
                name="bTooHot"
                data-cy="bTooHot"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.bStoppedFeeding')}
                id="gynaec-checklist-bStoppedFeeding"
                name="bStoppedFeeding"
                data-cy="bStoppedFeeding"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.bExcessiveCrying')}
                id="gynaec-checklist-bExcessiveCrying"
                name="bExcessiveCrying"
                data-cy="bExcessiveCrying"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.bUmblicalRedness')}
                id="gynaec-checklist-bUmblicalRedness"
                name="bUmblicalRedness"
                data-cy="bUmblicalRedness"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.mBleedingControlled')}
                id="gynaec-checklist-mBleedingControlled"
                name="mBleedingControlled"
                data-cy="mBleedingControlled"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.bFeedingNormal')}
                id="gynaec-checklist-bFeedingNormal"
                name="bFeedingNormal"
                data-cy="bFeedingNormal"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.bNotes')}
                id="gynaec-checklist-bNotes"
                name="bNotes"
                data-cy="bNotes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.mNotes')}
                id="gynaec-checklist-mNotes"
                name="mNotes"
                data-cy="mNotes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.active')}
                id="gynaec-checklist-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.cursor')}
                id="gynaec-checklist-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.lastupdated')}
                id="gynaec-checklist-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.microSec')}
                id="gynaec-checklist-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.gynaecChecklist.timestampentry')}
                id="gynaec-checklist-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                id="gynaec-checklist-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.gynaecChecklist.patient')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="gynaec-checklist-incident"
                name="incident"
                data-cy="incident"
                label={translate('tinyMedicRestApp.gynaecChecklist.incident')}
                type="select"
              >
                <option value="" key="0" />
                {laborIncidents
                  ? laborIncidents.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/gynaec-checklist" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default GynaecChecklistUpdate;
